//import OverViewService from "../../../../services/IpadPreview/Flight/overview.service";

const state = {
    aircraftList: [],
    aircraft: [],
    isActiveModal: false,

};
const mutations = {

    set_aircrafts_list(state, payload) {
        state.aircraftList = payload;
    },
    set_aircraft(state, payload) {
        state.aircraft = payload;
    },
    set_close_open_modal(state) {
        state.isActiveModal = !state.isActiveModal
    },
    set_clear_airport(state) {
        state.aircraft = [];
    }
};
const actions = {


};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
